import React from 'react';

import {
  Modal,
  ModelHeader,
  ModalBody,
  ModalFooter,
} from '../../common/input/modal/Modal';
import calimg from '../../assets/images/calculator-icon.png';
import logoimg from '../../assets/images/logo.png';

const CalculatorModal = (props) => {
  return (
    <>
      <Modal
        className="price-calculator-popup"
        show={props.modal_show}
        onHide={props.hideCalculator}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="price-calculator-pop-cont-wrap">
                <ModelHeader>
                  <div className="price-calculator-pop-header">
                    <h4>EARNING CALCULATOR</h4>
                    <h3>
                      Keep more of <span>What you Earn</span>
                    </h3>
                    <h2>Make the most of it Working for us</h2>
                  </div>
                </ModelHeader>
                <ModalBody>
                  <div className="red-price-box">
                    <div className="red-price-box-col">
                      <div className="wage-icon-text">
                        <img src={calimg} alt="" />
                        <span>Enter your Current Wage</span>
                      </div>
                    </div>
                    <div className="red-price-box-col wage-input-form">
                      <div className="form-group">
                        <label>Enter Wage</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue="£9.00"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pop-wage-info-row">
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <h4 className="pop-wage-info-hdng">Payscale Average</h4>
                        <ul className="pop-wage-info-list">
                          <li>
                            Description{' '}
                            <span className="float-right text-right">
                              Value
                            </span>
                          </li>
                          <li>
                            Industry Avg. :
                            <span className="float-right text-right">
                              <b>£16.00</b>
                            </span>
                          </li>
                          <li>
                            Our Commision:
                            <span className="float-right text-right">
                              <b>10%</b>
                            </span>
                          </li>
                          <li>
                            Avg. Wage we pay
                            <span className="float-right text-right">
                              <b>£14.40</b>
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6 col-12">
                        <h4 className="pop-wage-info-hdng red">
                          How much more you’ll make working for us
                        </h4>
                        <ul className="pop-wage-info-list red">
                          <li>
                            Description{' '}
                            <span className="float-right text-right">
                              Value
                            </span>
                          </li>
                          <li>
                            Hourly Wage:
                            <span className="float-right text-right">
                              <b>Improvement</b>
                            </span>
                          </li>
                          <li>
                            Increase per week:
                            <span className="float-right text-right">
                              <b>£216.00</b>
                            </span>
                          </li>
                          <li>
                            Increase per year:
                            <span className="float-right text-right">
                              <b>£11232.00</b>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ModalBody>

                <ModalFooter>
                  <div className="wage-pop-footer">
                    <h4>You keep more of your EarningsWorking with</h4>
                    <div className="logo">
                      <img src={logoimg} alt="" />
                    </div>
                  </div>
                </ModalFooter>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default CalculatorModal;
